<template>
  <div class="chat-container" :class="`theme-${currentTheme}`">
    <!-- 顶部标题区域 -->
    <header class="chat-header">
      <h1>{{ title }}</h1>
      <div class="theme-selector" v-if="showThemeSelector">
        <label for="theme-select">主题:</label>
        <select id="theme-select" v-model="currentTheme">
          <option v-for="(theme, key) in themes" :key="key" :value="key">{{ key }}</option>
        </select>
      </div>
    </header>

    <!-- 消息历史区域 -->
    <div ref="historybox" class="history-container">
      <ul class="message-list">
        <li v-for="item in chathistory" :key="item.id" :class="['message-item', item.role]">
          <!-- 助理头像 -->
          <img v-if="item.role === 'assistant'"
               src="@/assets/images/service_logo.png"
               alt="assistant"
               class="avatar assistant-avatar" />

          <!-- 加载动画 -->
          <img v-if="item.role === 'assistant' && item.content === ''"
               src="@/assets/images/loading.gif"
               alt="loading"
               class="avatar loading-indicator" />

          <!-- 消息内容容器 -->
          <div class="message-content-wrapper">
            <div class="message-container" 
     v-if="item.role === 'assistant' && item.content !== null && !item.content.includes('【系统提示】')">
  <!-- 优先显示formatted内容（HTML），如果不存在则显示格式化后的普通内容 -->
  <span v-html="item.formatted || formatContent(item.content)"/>
</div>

            <!-- 用户消息内容 -->
            <span v-if="item.role === 'user' && item.content !== null && !item.content.includes('【系统提示】')"
                  class="content user-message">
              {{ item.content }}
               <!-- 显示用户上传的图片 -->
                <div v-if="item.images && item.images.length > 0" class="message-images">
                  <div v-for="(img, imgIndex) in item.images" :key="imgIndex" class="message-image">
                    <img :src="img" alt="上传的图片"
                    @click="openImageViewer(img, item.images, imgIndex)"
                    class="clickable-image" style="cursor: pointer;"/>
                  </div>
                </div>
            </span>
          <!-- 用户头像 -->
          <img v-if="item.role === 'user' && item.content !== null && !item.content.includes('【系统提示】')"
               src="@/assets/images/user_logo.png"
               alt="user"
               class="avatar user-avatar" />
          </div>
        </li>
      </ul>
    </div>
<!-- 错误提示
<div v-if="hasError" class="error-message">
  <div class="error-content">
    <span>{{ errorMessage }}</span>
    <button @click="retrySubmit" class="retry-btn">重试</button>
  </div>
</div> -->
    <!-- 输入区域 -->
    <div class="input-container" :class="{ 'has-error': hasError }">
      <textarea :class="(isReady && !isInConversation)?'':'locked'" :disabled="!isReady || isInConversation"
                v-model="msg"
                @keyup.enter="submit"
                :placeholder="placeholderText"
               ></textarea>
     <!-- 图片上传区域 -->
     <div class="image-upload-container" v-if="!isInConversation">

        <div class="button-bar">
      
          <label for="image-upload" class="upload-label btn btn-secondary">
          <svg t="1756477905919" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7349" width="16" height="16">
            <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136V232h752v560zM610.5 476h90c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-90c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8zM340.5 676h290c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-290c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8z" fill="#057FDB" p-id="7350"></path>
          </svg>
          添加图片
        </label>
              <button class="btn btn-secondary" @click="newChat" title="新建会话">
                <svg t="1756477415452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5469" width="16" height="16"><path d="M512 64c123.712 0 235.712 50.144 316.784 131.216l0.418 0.422-56.567 56.567-0.42-0.42C703.595 183.165 611 144 512 144c-203.24 0-368 164.76-368 368 0 59.38 14.017 116.576 40.533 168.103 5.522 10.731 7.958 20.057 9.634 30.936 0.908 5.897 1.508 12.238 1.917 19.39 0.674 11.801 0.855 26.67 0.602 45.038-0.254 18.377-0.953 40.61-2.095 66.75l-0.035 0.78 0.593-0.052c25.557-2.227 47.42-3.85 65.642-4.87l1.047-0.058c14.695-0.809 27.215-1.236 37.785-1.256h1.61c2.128 0.004 4.173 0.026 6.14 0.065 7.29 0.144 13.796 0.525 19.874 1.248 10.762 1.28 20.193 3.403 30.871 8.327C405.912 868.439 458.061 880 512 880c98.961 0 191.524-39.134 260.136-107.705l56.567 56.567-2.36 2.345C745.47 910.854 634.474 960 512 960c-66.898 0-130.37-14.663-187.38-40.95-11.286-5.204-77.842-1.538-199.668 10.997a13 13 0 0 1-2.09 0.047c-7.167-0.419-12.638-6.568-12.22-13.736l0.213-3.666c6.954-120.437 7.802-185.765 2.544-195.984C81.824 655.35 64 585.756 64 512 64 264.576 264.576 64 512 64z m298.48 259.297a22.306 22.306 0 0 1 13.535 13.536l36.91 103.707a22.306 22.306 0 0 0 13.535 13.535l103.707 36.91c11.606 4.13 17.666 16.888 13.536 28.494a22.306 22.306 0 0 1-13.536 13.536l-103.707 36.91a22.306 22.306 0 0 0-13.535 13.535l-36.91 103.707c-4.13 11.606-16.888 17.666-28.494 13.536a22.306 22.306 0 0 1-13.536-13.536l-36.91-103.707a22.306 22.306 0 0 0-13.535-13.535l-103.707-36.91c-11.606-4.13-17.666-16.888-13.536-28.494a22.306 22.306 0 0 1 13.536-13.536l103.707-36.91a22.306 22.306 0 0 0 13.535-13.535l36.91-103.707c4.13-11.606 16.888-17.666 28.494-13.536z" p-id="5470" fill="#057FDB"></path></svg>
                新建会话</button>
              <button v-if="isReady && !isInConversation" class="btn btn-primary" @click="submit" title="tips:按回车键发送消息">
                <svg t="1756476817513" class="icon" style="margin-right: 5px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4409" width="16" height="16"><path d="M928 213.333333H640v-42.666666h42.666667a21.333333 21.333333 0 0 0 12.8-38.4l-170.666667-128a21.333333 21.333333 0 0 0-25.6 0l-170.666667 128A21.333333 21.333333 0 0 0 341.333333 170.666667h42.666667v42.666666H96a53.393333 53.393333 0 0 0-53.333333 53.333334v661.333333a53.393333 53.393333 0 0 0 53.333333 53.333333h832a53.393333 53.393333 0 0 0 53.333333-53.333333V266.666667a53.393333 53.393333 0 0 0-53.333333-53.333334zM512 48l106.666667 80a21.333333 21.333333 0 0 0-21.333334 21.333333v234.666667H426.666667V149.333333a21.333333 21.333333 0 0 0-21.333334-21.333333zM384 256v149.333333a21.333333 21.333333 0 0 0 21.333333 21.333334h213.333334a21.333333 21.333333 0 0 0 21.333333-21.333334V256h268.5L519.54 644.953333a10.666667 10.666667 0 0 1-15.08 0L115.5 256z m-298.666667 652.5v-622.333333L396.5 597.333333z m30.166667 30.166667L426.666667 627.5l47.62 47.626667a53.4 53.4 0 0 0 75.426666 0L597.333333 627.5 908.5 938.666667zM938.666667 908.5L627.5 597.333333 938.666667 286.166667z" fill="#ffffff" p-id="4410"></path></svg>提交</button>
              <button v-if="isInConversation" class="btn btn-accent" @click="stop" title="结束对话">
                <svg t="1756477905919" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7349" width="16" height="16"><path d="M128 128m170.666667 0l426.666666 0q170.666667 0 170.666667 170.666667l0 426.666666q0 170.666667-170.666667 170.666667l-426.666666 0q-170.666667 0-170.666667-170.666667l0-426.666666q0-170.666667 170.666667-170.666667Z" fill="#ffffff" p-id="7350"></path>结束对话</svg>
                </button>
            </div>
        <input
          type="file"
          id="image-upload"
          accept="image/*"
          multiple
          @change="handleImageUpload"
          style="display: none;"
        >
<!--
        图片上传进度 -->
<div v-if="isUploading" class="upload-progress">
  <div class="progress-bar">
    <div class="progress-fill" :style="{ width: uploadProgress + '%' }"></div>
  </div>
  <span>上传中: {{ uploadProgress }}%</span>
</div>
        <!-- 图片预览区域 -->
        <div class="image-previews" v-if="uploadedImages.length > 0">
          <div v-for="(image, index) in uploadedImages" :key="index" class="image-preview">
            <img :src="image.preview" alt="预览图"
           @click="openPreviewImage(image.preview, index)"
            class="clickable-image">
            <button class="remove-image" @click="removeImage(index)">×</button>
          </div>
        </div>
     </div>

    </div>
  <div v-if="imageViewer.visible" class="image-viewer-modal" @click.self="closeImageViewer">
    <div class="image-viewer-content">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="closeImageViewer">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
        </svg>
      </button>

      <!-- 导航按钮 -->
      <button v-if="imageViewer.imageList.length > 1" class="nav-btn prev-btn" @click="showPrevImage">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"/>
        </svg>
      </button>

      <button v-if="imageViewer.imageList.length > 1" class="nav-btn next-btn" @click="showNextImage">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/>
        </svg>
      </button>

      <!-- 图片显示 -->
      <div class="image-container">
        <img :src="imageViewer.currentImage" alt="查看图片" @load="onImageLoad" @error="onImageError">

        <!-- 加载指示器 -->
        <div v-if="isImageLoading" class="loading-indicator">
          <div class="spinner"></div>
        </div>
      </div>

      <!-- 缩略图导航 -->
      <div v-if="imageViewer.imageList.length > 1" class="thumbnail-nav">
        <div
          v-for="(img, index) in imageViewer.imageList"
          :key="index"
          :class="['thumbnail', { active: index === imageViewer.currentIndex }]"
          @click="switchImage(index)"
        >
          <img :src="getThumbnailUrl(img)" alt="缩略图">
        </div>
      </div>

      <!-- 图片信息 -->
      <div class="image-info">
        <span>{{ imageViewer.currentIndex + 1 }} / {{ imageViewer.imageList.length }}</span>
        <a v-if="imageViewer.currentImage" :href="imageViewer.currentImage" download target="_blank" class="download-btn">
          下载原图
        </a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {newThread,sendStreamChatRequest } from '@/api/chat/chat';
import { LOCAL_API_URL, http } from "@/api/base";
import {
  initWebSocket,
  registerCallback,
  unregisterCallback,
  closeWebSocket,
  getConnectionState,
  waitForConnection,
  attemptReconnect
} from '@/api/chat/websocket';

// 高亮显示代码
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css' // 选择一款主题
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import { BASE_PROCESSORS, createCodeProcessor } from '/public/utils/processors';

// 引入主题配置
import { themes } from '/public/utils/themes';

// 注册语言
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('json', json)

export default {
  name: 'ChatView',


  data() {
  return {
    hasWelcomed: false, // 是否已向用户介绍了系统提示词
    msg: '',
    errorMessage: '', // 错误消息状态
    hasError: false,  // 错误状态标志
    keyboardHandler: null, // 添加键盘事件处理器引用
    isUploading: false, // 添加上传状态
    uploadProgress: 0,  // 上传进度
    timer: null,
    debounceTimer: null, // 添加防抖计时器
    chathistory: [],
    aiSeatId: 1, // 机器人座席ID
    slug: "test",
    threadSlug: "",
    mode: "query",
    isReady: false, // 是否准备就绪，用于控制按钮显示。建立连接后与对话中之间的时段isReady为true。
    isStopped: false, // 是否已停止对话
    isInConversation: true, // 是否处于对话中
    CONTENT_PROCESSORS: {
      ...BASE_PROCESSORS,  // 包含 br 、 bold和table 等处理器
      ...createCodeProcessor(this._highlightCode)  // 包含 code
    },
    pendingCodeBlocks: new Set(),
    codeHighlightTimer: null,
    updateReply: null, // 用于存储回调引用
    currentTheme: 'default', // 当前主题
    themes: themes, // 所有可用主题
    showThemeSelector: true, // 是否显示主题选择器
    formatTimeout: null, // 添加格式化超时变量
    uploadedImages: [], // 存储上传的图片
    maxImageSize: 5 * 1024 * 1024, // 最大图片大小5MB
    imageViewer: {
      visible: false,      // 是否显示弹框
      currentImage: '',    // 当前查看的图片URL
      currentIndex: 0,     // 当前图片索引
      imageList: [],        // 所有图片列表
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      reconnectDelay: 1000, // 初始延迟1秒
      isServiceUnavailable: false,
      reconnectTimer: null
    }
  }
},
  computed: {
    placeholderText() {
      if(this.isStopped) return '对话已停止...';
      if(!this.isReady) return '正在连接服务器...';
      return this.isInConversation ? '对话已锁定...' : '请输入您的问题...';
    }
  },
  watch: {
    chathistory: {
      deep: true,
      handler(newVal, oldVal) {
        // 只有当消息内容实际发生变化时才进行格式化
        const contentChanged = newVal.some((item, index) => {
          return !oldVal[index] || item.content !== oldVal[index].content;
        });

        if (contentChanged) {
          this.chathistory.forEach((item, index) => {
            if (item.role === 'assistant' && item.content && !item.formatted) {
              console.log('格式化消息:', index, item.content);
              const formatted = this.formatContent(item.content);
              this.$set(this.chathistory[index], 'formatted', formatted);
            }
          });
        }

        this.$nextTick(() => {
          const container = this.$refs.historybox;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
          this.highlightAllCodeBlocks();
        });
      }
    },
    // 监听主题变化，应用到HTML根元素
    currentTheme(newTheme) {
      document.documentElement.setAttribute('data-theme', newTheme);
    }
  },
  props: {
    title: {
      type: String,
      default: 'AI智能客服'
    },
    // 新增配置属性
    config: {
      type: Object,
      default: () => ({
        showThemeSelector: true,
        defaultTheme: 'default'
      })
    }
  },
  async created() {
    console.log("ChatView created", this.slug);
    try {
      const response = await newThread(this.slug);
      console.log("创建线程结果，response:", response);
      this.threadSlug = response.thread.slug;
      console.log("创建线程成功，threadSlug:", this.threadSlug);

      await this.initializeWebSocket();

    } catch (error) {
      console.error("初始化失败:", error);
      this.handleError(`初始化失败: ${error.message}`);
    }
  },




  mounted() {
    this.setupCopyButtons();
    // 初始代码高亮
    this.$nextTick(() => {
      document.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
      });
    });
  },
  beforeDestroy() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    // 组件销毁时取消注册并关闭连接
    if (this.updateReply) {
      unregisterCallback(this.threadSlug, this.updateReply);
    }
    closeWebSocket(this.threadSlug);
    this.removeKeyboardEvents();

    // 清理错误状态
    this.hasError = false;
    this.errorMessage = '';
  },
  updated() {
    this.$nextTick(() => {
      // 高亮所有代码块
      document.querySelectorAll('pre code:not(.hljs)').forEach((block) => {
        hljs.highlightBlock(block);
      });

      // 重新设置复制按钮
      this.setupCopyButtons();
    });
  },
  methods: {
    async sendWelcomeMessage() {
      // 先显示欢迎消息占位
      this.chathistory.push({
        id: this.chathistory.length + 1,
        role: "assistant",
        content: "正在连接中..."
      });

      // 短暂延迟让用户看到连接状态
      await new Promise(resolve => setTimeout(resolve, 300));

      // 发送欢迎请求
      const welcomeRequest = {
        aiSeatId: this.aiSeatId,
        workspaceSlug: this.slug,
        message: "【系统提示】请说欢迎语", // 特殊的欢迎触发消息
        threadSlug: this.threadSlug,
        reset: false,
        mode: "chat", // 欢迎词用chat模式

      };

      sendStreamChatRequest(welcomeRequest);
    },
    // 处理图片上传
    // 修改handleImageUpload方法，添加调试
    handleImageUpload(event) {
      console.log('handleImageUpload called', event.target.files);

      const files = event.target.files;
      if (!files || files.length === 0) {
        console.log('No files selected');
        return;
      }

      // 检查总图片数量限制
      const totalAfterUpload = this.uploadedImages.length + files.length;
      if (totalAfterUpload > 6) {
        this.$message.error('每天最多上传6张图片');
        event.target.value = '';
        return;
      }

      // 使用Promise.all来确保所有图片都处理完成
      const promises = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log('Processing file:', file.name, file.type, file.size);

        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('请上传图片文件');
          continue;
        }

        // 检查文件大小
        if (file.size > this.maxImageSize) {
          this.$message.error('图片大小不能超过5MB');
          continue;
        }

        const promise = new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log('FileReader loaded:', file.name);
            resolve({
              file: file,
              preview: e.target.result,
              name: file.name
            });
          };
          reader.onerror = (error) => {
            console.error('FileReader error:', error);
            this.$message.error('图片读取失败');
            resolve(null);
          };
          reader.readAsDataURL(file);
        });

        promises.push(promise);
      }

      Promise.all(promises).then((newImages) => {
        // 过滤掉null值（读取失败的图片）
        const validImages = newImages.filter(img => img !== null);

        if (validImages.length > 0) {
          console.log('Adding new images:', validImages.length);
          // 使用Vue.set或者直接赋值确保响应式更新
          this.uploadedImages = [...this.uploadedImages, ...validImages];
          console.log('Total images now:', this.uploadedImages.length);
        }
      });

      // 清空input
      event.target.value = '';
    },

    // 移除已选图片
    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },
    // 清空所有已选图片
    clearAllImages() {
      this.uploadedImages = [];
    },
    newChat() {
      window.location.reload();
      this.msg = '';
      this.$emit('new-chat');
    },
    // 确保 debounceUpdate 能处理HTML内容
    debounceUpdate(content, isHtmlContent = false) {
      // 检查是否为HTML内容（如果没有传入isHtmlContent参数）
      const checkIsHtml = isHtmlContent || content.includes('<img') || content.includes('<div');
      
      // 清除之前的定时器
      clearTimeout(this.updateTimer);
      
      // 设置新的定时器
      this.updateTimer = setTimeout(() => {
        // 找到最后一条助手消息
        const lastAssistantMsg = this.chathistory
          .filter(msg => msg.role === 'assistant')
          .pop();
        
        if (lastAssistantMsg) {
          // 如果消息已经标记为HTML，直接替换
          if (checkIsHtml) {
            console.log("更新HTML内容到formatted字段");
            lastAssistantMsg.formatted = content;
          } else {
            // 原有的流式更新逻辑
            lastAssistantMsg.content = content;
          }
          
          // 触发视图更新
          this.$forceUpdate();
          
          // 滚动到底部
          this.$nextTick(() => {
            const container = this.$refs.historybox;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          });
        }
      }, 50); // 50ms防抖
    },

    async uploadImageToOSS(file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('threadId', this.threadSlug);


        const response = await http.post(
          `${LOCAL_API_URL}/api/chat/upload-image`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        console.log('图片上传成功:', response.data.url);
        return response.data.url;

    },
     // 错误处理方法
     handleError(error) {
      console.error("处理错误:", error);

      this.hasError = true;
      this.errorMessage = error;
      this.isInConversation = false;
      this.isUploading = false;

      // 移除空的助手消息
      this.removeEmptyAssistantMessage();

      // 显示错误消息
      this.$message.error(error);

      // 如果是连接相关错误，尝试重连
      if (error.includes('连接') || error.includes('关闭') || error.includes('失败')) {
        this.reconnectWebSocket();
      }
    },
    // 单独的回调注册方法
    registerCallback() {
      this.updateReply = (content, status = false, error = null) => {
        console.log("收到回调:", { content, status, error });    
        
        // 检查内容是否包含HTML标签
        const isHtmlContent = content && (content.includes('<img') || content.includes('<div') || 
                            content.includes('<table') || content.includes('<pre') || content.includes('<span'));
        console.log("内容是否为HTML:", isHtmlContent, "内容长度:", content ? content.length : 0);
        
        if (error) {
          console.error("收到错误:", error);
          // 移除刚才添加的历史记录
          if (this.chathistory.length >= 2) {
            this.chathistory.pop();
            this.chathistory.pop();
          }
          this.handleError(error);
          return;
        }

        // 处理CONVERSATION_TIMEOUT消息（超时未响应）    
        if (status === 'conversation_timeout') {
          console.log("收到完整的对话结束消息（用户超时未响应）");
          // 解析CONVERSATION_TIMEOUT消息
          const conversation_timeout_processed_obj = JSON.parse(content);
          console.log("conversation_timeout_processed_obj", conversation_timeout_processed_obj);
          const replyObj = JSON.parse(conversation_timeout_processed_obj.reply);
          console.log("解析成功:", replyObj);
          const userMessage = replyObj.reply || "感谢您的咨询！";
          
          // 防重复处理：检查是否已经有系统留言
          const hasTimeoutMessage = this.chathistory.some(item => item.isTimeoutMessage);
          const hasRatingInvitation = this.chathistory.some(item => item.isRatingInvitation);
          
          if (hasTimeoutMessage || hasRatingInvitation) {
            console.log("已经处理过CONVERSATION_TIMEOUT消息，跳过重复处理");
            return;
          }
          
          // 1. 显示AI的留言（从reply字段获取）
          console.log("CONVERSATION_TIMEOUT消息的reply: "+userMessage);
          this.chathistory.push({
            id: Date.now(),
            role: "assistant",
            content: userMessage,
            isTimeoutMessage: true, // 标记为超时消息
            timestamp: new Date()
          });
          
          // 2. 显示邀请评价的消息
          this.showUserRating(replyObj)

          
          // 3. 对话结束，重置状态
          this.isInConversation = false;
          
          // 4. 滚动到底部
          this.$nextTick(() => {
            const container = this.$refs.historybox;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          });
          
          return;
        }

        // 处理最终完成的情况
        if (status === true) {
          console.log("对话已完成，内容是否为HTML:", isHtmlContent);
          this.isInConversation = false;
          this.isUploading = false;
          
          // 更新最后一条AI消息的内容
          const lastMessageIndex = this.chathistory.length - 1;
          if (lastMessageIndex >= 0 && this.chathistory[lastMessageIndex].role === 'assistant') {
            // 如果是HTML内容，标记为已格式化
            if (isHtmlContent) {
              console.log("设置HTML内容到formatted字段");
              this.chathistory[lastMessageIndex].content = content;
              this.chathistory[lastMessageIndex].formatted = content; // 直接使用HTML
            } else {
              this.chathistory[lastMessageIndex].content = content;
            }
            
            // 强制更新视图
            this.$forceUpdate();
            
            // 滚动到底部
            this.$nextTick(() => {
              const container = this.$refs.historybox;
              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            });
          }
        } 
        // 处理流式更新（普通内容）
        else if (content) {
          this.debounceUpdate(content, isHtmlContent);
        }
      };

      registerCallback(this.threadSlug, this.updateReply);
      console.log("回调注册完成");
      
      if (!this.hasWelcomed) {
        this.sendWelcomeMessage().then(() => {
          this.hasWelcomed = true;
        });
      }
    },

    // 新增：设置复制按钮
    // 新增WebSocket初始化方法
    async initializeWebSocket() {
      if (this.isServiceUnavailable || this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.log("服务不可用或已达最大重试次数，停止重连");
        return;
      }
      try {
        // 初始化WebSocket
        initWebSocket(this.threadSlug, this.aiSeatId, this.workspaceSlug);

        // 设置超时时间，随重试次数增加
        const timeout = Math.min(3000 + this.reconnectAttempts * 1000, 10000);
        // 等待连接建立
        await waitForConnection(this.threadSlug, timeout);
        console.log(`[${this.threadSlug}] WebSocket连接成功`);

        // 重置重试计数
        this.reconnectAttempts = 0;
        this.reconnectDelay = 1000;
        this.isServiceUnavailable = false;

        // 注册回调
        this.registerCallback();


        this.isReady = true;
        this.isStopped = false;

      } catch (error) {
        console.error("WebSocket连接失败:", error);
        this.handleError(`连接失败: ${error.message}`);


       // 指数退避策略
        this.reconnectAttempts++;
        this.reconnectDelay = Math.min(this.reconnectDelay * 2, 30000); // 最大30秒

        if (error.message.includes('连接拒绝') || error.message.includes('503')) {
          this.isServiceUnavailable = true;
          this.handleError(`服务暂时不可用，${this.reconnectDelay/1000}秒后重试`);
        } else {
          this.handleError(`连接失败: ${error.message}`);
        }

        // 安排重试
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectTimer = setTimeout(() => {
            this.initializeWebSocket();
          }, this.reconnectDelay);
        }
      }
    },
    // 新增：移除空的助手消息
    removeEmptyAssistantMessage() {
      console.log("移除刚才添加的历史记录..",this.chathistory);
      if (this.chathistory.length > 0 &&
          this.chathistory[this.chathistory.length - 1].role === 'assistant' &&
          this.chathistory[this.chathistory.length - 1].content === '') {
        this.chathistory.pop();
      }
    },

    // 新增：重连WebSocket
    async reconnectWebSocket() {
      console.log("尝试重新连接WebSocket...");

      // 先取消注册旧回调
      if (this.updateReply) {
        unregisterCallback(this.threadSlug, this.updateReply);
      }

      // 关闭旧连接
      closeWebSocket(this.threadSlug);

      // 重新初始化
      attemptReconnect(this.threadSlug);
      //await this.initializeWebSocket();
    },

    async submit() {
      // 检查连接状态，如果断开则重连
      const state = getConnectionState(this.threadSlug);
      if (state === '已关闭' || state === '不存在') {
        console.log("连接已断开，正在重连...");
        await this.reconnectWebSocket();
      }

      // 重置错误状态
      this.hasError = false;
      this.errorMessage = '';

      // 验证输入
      if ((this.msg == null || this.msg.trim() === '') && this.uploadedImages.length === 0) {
        this.$message.error("请输入内容或上传图片");
        return;
      }
      if(this.uploadedImages.length>3){
        this.$message.error("最多只能上传3张图片");
        return;
      }

      if(this.msg.trim().length>1000){
        this.$message.error("最多只能输入1000个字符");
        return;
      }
      if(this.msg.trim().includes("系统提示词")){
        this.$message.error("请勿输入系统提示词");
        return;
      }
      // 检查是否已有错误或正在对话中
      if (this.hasError || this.isInConversation) {
            return;
      }
      this.isInConversation = true;
      this.isUploading = true;
      this.uploadProgress = 0;

      // 1. 先上传图片到OSS，获取URL
      let upload_error = false;
      const imageUrls = [];
      console.log("上传图片...", this.uploadedImages);
      for (const img of this.uploadedImages) {
        console.log("上传图片:", img.name);
        try {
          const url = await this.uploadImageToOSS(img.file);
          imageUrls.push(url);
        } catch (error) {
          upload_error=true;
          if (error.response && error.response.status === 429) {
          this.$message.error('上传图片数量超过今天的限额');


        }

          this.isInConversation = false;

          this.isUploading = false;
        }
      }
      this.isUploading = false;
      // 2. 构建最终消息内容（将图片URL整合到文本中）
      let finalMessage = this.msg.trim();
      console.log("imageUrls:", imageUrls)

      if (this.uploadedImages.length > 0) {
        // 将图片URL添加到消息内容中
        const imageReferences = imageUrls.map(url => `[图片](${url})`).join(' ');
        finalMessage = finalMessage ? `${finalMessage}\n${imageReferences}` : imageReferences;


      // 3. 添加到聊天历史（显示用）

      if (!upload_error) {
        this.chathistory.push({

          "id": this.chathistory.length + 1,
          "role": "user",
          "content": this.msg.trim(), // 使用包含图片URL的完整消息
          "images": this.uploadedImages.map(img => img.preview) // 存储预览图用于显示
        });

        // 4. 添加助手回复占位
        this.chathistory.push({
          "id": this.chathistory.length + 1,
          "role": "assistant",
          "content": ""
        });
      }
    }else {
      const currentMsg = this.msg.trim();
      console.log("发送消息：" + currentMsg);
      this.isInConversation = true;
      this.chathistory.push({ "id": this.chathistory.length + 1, "role": "user", "content": currentMsg });
      this.chathistory.push({ "id": this.chathistory.length + 1, "role": "assistant", "content": "" });
    }

      // 5. 构造请求对象（根据后端API调整）
      const requestData = {
        aiSeatId: this.aiSeatId,
        workspaceSlug: this.slug,
        message: finalMessage, // 包含图片URL的完整消息
        threadSlug: this.threadSlug,
        reset: false,
        mode: this.mode,
        // 根据后端支持情况决定是否添加images字段
        ...(imageUrls.length > 0 && { imageUrls: imageUrls })
      };

      console.log("发送消息:", finalMessage, "图片URL:", imageUrls);

      try {
        // 6. 发送请求
        await sendStreamChatRequest(requestData);
      } catch (error) {
        console.error("发送消息失败:", error);
        this.$message.error("消息发送失败");
        // 可以考虑移除刚才添加的历史记录
        console.log("移除刚才添加的历史记录..",this.chathistory);
        this.chathistory.pop(); // 移除助手占位
        this.chathistory.pop(); // 移除用户消息
        console.log("移除完毕..",this.chathistory);
        this.isInConversation = false;
        this.isUploading = false;
        return;
      }

      // 7. 清空输入
      this.msg = "";
      this.clearAllImages();

      // 8. 保持焦点
      this.$nextTick(() => {
        const textarea = this.$el.querySelector('textarea');
        if (textarea) {
          textarea.focus();
        }
      });
    },
    stop() {
      // 1. 关闭WebSocket连接
      closeWebSocket(this.threadSlug);

      // 2. 更新UI状态
      this.isInConversation = false;
      this.isStopped = true;
      this.isReady = false;
      this.placeholderText = "对话已经停止...";

      // 3. 可选：添加停止提示到历史记录
      this.chathistory[this.chathistory.length - 1] = {
        id: this.chathistory.length + 1,
        role: "assistant",
        content: "已收到您的指令，对话已停止。您可以点击【开启新对话】重新开启对话。"
      };

  console.log(`对话已停止，线程: ${this.threadSlug}`);

  // 4. 触发事件
  this.$emit('stop-chat');
    },
    hasCompleteTable(content) {
    if (!content.includes('|')) return false;

    const lines = content.split('\n');

    // 检查是否有表头、分隔线和至少一行数据
    if (lines.length < 3) return false;

    // 检查分隔线特征（包含 - 或 :）
    const hasSeparator = lines.some(line =>
      line.includes('-') || line.includes(':')
    );

    // 检查是否有完整的数据行
    const hasDataRows = lines.filter(line =>
      line.includes('|') && !line.includes('-') && !line.includes(':')
    ).length >= 1;

    return hasSeparator && hasDataRows;
    },
    formatContent(content) {
      if (!content) return '';

      console.log('=== 开始格式化内容 ===');
      console.log('原始内容:', content);

      // 如果内容已经包含HTML标签，直接返回（避免重复处理）
      if (/<(ul|ol|li|div|table|pre|code)[^>]*>/i.test(content)) {
        console.log('内容已包含HTML，跳过处理');
        return content;
      }

      let processed = content;

      // 确保标题处理器在正确的位置（在换行处理器之前）
      const processors = ['table', 'list', 'heading', 'br', 'bold', 'code', 'link', 'emphasis', 'flowchart'];

      processors.forEach(processorName => {
        if (this.CONTENT_PROCESSORS[processorName]) {
          const before = processed;
          processed = this.CONTENT_PROCESSORS[processorName](processed);

          if (processed !== before) {
            console.log(`✅ 处理 ${processorName} 后内容发生变化`);
            console.log(`处理 ${processorName} 后:`, processed.substring(0, 200) + '...'); // 只显示前200字符
          } else {
            console.log(`➖ 处理 ${processorName} 后内容未变化`);
          }
        } else {
          console.log(`❌ 处理器 ${processorName} 不存在`);
        }
      });

      console.log('=== 最终处理结果 ===', processed);
      return processed;
    },
    _highlightCode(lang, code) {
        try {
          // 确保代码中的换行符保留
          const result = hljs.highlight(code, {
            language: lang || 'plaintext'
          }).value;

          return result;
        } catch (e) {
          console.error('高亮失败:', e);
          return code; // 返回原始代码（保留换行）
        }
    },
    delayHighlightCodeBlocks() {
      if (this.codeHighlightTimer) {
        clearTimeout(this.codeHighlightTimer);
      }

      this.codeHighlightTimer = setTimeout(() => {
        this.highlightPendingCodeBlocks();
      }, 1000); // 1秒延迟，确保代码块完整
    },
    highlightPendingCodeBlocks() {
      this.$nextTick(() => {
        const codeBlocks = this.$el.querySelectorAll('.code-block:not(.highlighted)');

        codeBlocks.forEach(block => {
          const lang = block.getAttribute('data-lang');
          const rawCode = block.getAttribute('data-code')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'");

          try {
            const highlighted = hljs.highlight(rawCode, {
              language: lang || 'plaintext',
              ignoreIllegals: true
            }).value;

            const codeElement = block.querySelector('code');
            if (codeElement) {
              codeElement.innerHTML = highlighted;
              block.classList.add('highlighted');
            }
          } catch (e) {
            console.error('代码高亮失败:', e);
          }
        });

        this.setupCopyButtons();
      });
    },
    // 安全相关方法
    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    _restoreValidTags(content) {
      const allowedTags = {
        '&lt;strong&gt;': '<strong>',
        '&lt;/strong&gt;': '</strong>',
        '&lt;br/&gt;': '<br/>',
        '&lt;br&gt;': '<br>'
      };
      return content.replace(
        /&lt;(\/?)(strong|br\/?)(&gt;)/g,
        match => allowedTags[match] || match
      );
    },
    setupCopyButtons() {
      this.$nextTick(() => {
        const container = this.$refs.historybox;
        if (!container) return;

        container.querySelectorAll('.copy-btn').forEach(btn => {
          btn.onclick = () => {
            const codeId = btn.getAttribute('data-code-id');
            const codeBlock = document.getElementById(codeId);
            if (codeBlock) {
              navigator.clipboard.writeText(codeBlock.textContent)
                .then(() => {
                  const textSpan = btn.querySelector('.copy-text');
                  if (textSpan) textSpan.textContent = '已复制';
                  setTimeout(() => {
                    if (textSpan) textSpan.textContent = '复制';
                  }, 2000);
                });
            }
          };
        });
      });
    },
    // 添加这个方法到 methods 中
    highlightAllCodeBlocks() {
      this.$nextTick(() => {
        document.querySelectorAll('pre code').forEach((block) => {
          // 先检查是否已经高亮过
          if (!block.classList.contains('hljs')) {
            hljs.highlightBlock(block);
          }
        });

        // 重新设置复制按钮
        this.setupCopyButtons();
      });
    },
    // 打开图片查看器
    openImageViewer(imageUrl, imageList = null, index = 0) {
      // 如果没有传入图片列表，则使用当前消息的所有图片
      const imagesToShow = imageList || this.getCurrentMessageImages();

      this.imageViewer = {
        visible: true,
        currentImage: imageUrl,
        currentIndex: index,
        imageList: imagesToShow
      };

      // 禁止背景滚动
      document.body.style.overflow = 'hidden';

      // 添加键盘事件监听
      this.addKeyboardEvents();
    },
    // 关闭图片查看器
    closeImageViewer() {
      this.imageViewer.visible = false;
      document.body.style.overflow = '';
      this.removeKeyboardEvents();
    },
    // 显示上一张图片
    showPrevImage() {
      if (this.imageViewer.imageList.length <= 1) return;

      const newIndex = (this.imageViewer.currentIndex - 1 + this.imageViewer.imageList.length) %
                      this.imageViewer.imageList.length;
      this.switchImage(newIndex);
    },
    // 显示下一张图片
    showNextImage() {
      if (this.imageViewer.imageList.length <= 1) return;

      const newIndex = (this.imageViewer.currentIndex + 1) % this.imageViewer.imageList.length;
      this.switchImage(newIndex);
    },
    // 切换到指定图片
    switchImage(index) {
      this.isImageLoading = true;
      this.imageViewer.currentIndex = index;
      this.imageViewer.currentImage = this.imageViewer.imageList[index];
    },
    // 获取当前消息的所有图片（用于多图导航）
    getCurrentMessageImages() {
      // 这里可以根据需要实现获取当前消息所有图片的逻辑
      // 例如从当前聊天记录中提取所有图片URL
      return this.uploadedImages.map(img => img.preview);
    },
    // 生成缩略图URL（如果是OSS图片，可以生成缩略图版本）
    getThumbnailUrl(imageUrl) {
      // 如果是OSS图片，可以添加缩略图参数
      if (imageUrl.includes('oss.aliyuncs.com')) {
        return imageUrl + '?x-oss-process=image/resize,w_100';
      }
      return imageUrl;
    },
    // 图片加载完成
    onImageLoad() {
      this.isImageLoading = false;
    },
    // 图片加载失败
    onImageError() {
      this.isImageLoading = false;
      this.$message.error('图片加载失败');
    },
    // 专门用于查看预览图的方法
    openPreviewImage(previewUrl, index) {
      this.imageViewer = {
        visible: true,
        currentImage: previewUrl,
        currentIndex: index,
        imageList: this.uploadedImages.map(img => img.preview) // 所有预览图
      };
      document.body.style.overflow = 'hidden';
    },
    //添加键盘事件
    addKeyboardEvents() {
      // 先移除可能存在的旧监听器
      this.removeKeyboardEvents();

      this.keyboardHandler = (e) => {
        if (e.key === 'Escape') this.closeImageViewer();
        if (e.key === 'ArrowLeft') this.showPrevImage();
        if (e.key === 'ArrowRight') this.showNextImage();
      };
      window.addEventListener('keydown', this.keyboardHandler);
    },

    // 移除键盘事件
    removeKeyboardEvents() {
      if (this.keyboardHandler) {
        window.removeEventListener('keydown', this.keyboardHandler);
        this.keyboardHandler = null;
      }
    },
    // 添加重试方法
    retrySubmit() {
      this.hasError = false;
      this.errorMessage = '';
      this.submit();
    }
  }

}
</script>

<style scoped>
/* 基础布局样式 */
.chat-container {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 100%;
  margin: 0 auto;
  background-color: var(--background-color, #f5f5f5);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

/* 头部样式 */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--primary-color, #057FDB);
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.chat-header h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.theme-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.theme-selector label {
  font-size: 0.9rem;
}

.theme-selector select {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.3);
  background-color: rgba(255,255,255,0.2);
  color: white;
}

/* 消息历史区域 */
.history-container {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  background-color: var(--background-color, #f5f5f5);
}

.message-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 1200px;
  margin: 0 auto;
}

.message-item {
  display: flex;
  margin-bottom: 1rem;
  align-items: flex-start;
}

.message-item.user {
  flex-direction: row-reverse;
}

/* 头像样式 */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.assistant-avatar {
  margin-right: 12px;
}

.user-avatar {
  margin-left: 12px;
  float: right;
}

.loading-indicator {
  width: 24px !important;
  height: 24px !important;
  margin-right: 16px;
}

/* 消息内容区域 */
.message-content-wrapper {
  max-width: 70%;
}

.message-container {
  background-color: var(--assistant-msg-bg, #42b983);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  max-width: 100%;
  line-height: 1.5;
}

.user .message-content-wrapper {
  display: flex;
  justify-content: flex-end;
}

.user .message-container {
  background-color: var(--user-msg-bg, deepskyblue);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 18px;
}

.user-message {
  background-color: var(--user-msg-bg, deepskyblue);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 18px;
  border-bottom-right-radius: 4px;
  display: inline-block;
  max-width: 100%;
  line-height: 1.5;
}

/* 输入区域 */
.input-container {
  padding: 1rem 1.5rem;
  background-color: white;
  border-top: 1px solid var(--border-color, #e1e4e8);
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
}

.input-container textarea {
  width: 100%;
  min-height: 80px;
  padding: 0.75rem;
  border: 2px solid var(--primary-color, #057FDB);
  border-radius: 8px;
  resize: vertical;
  font-size: 1rem;
  font-family: inherit;
  box-sizing: border-box;
}

.input-container textarea:focus {
  outline: none;
  border-color: var(--primary-color-dark, #0460a9);
  box-shadow: 0 0 0 3px rgba(5, 127, 219, 0.2);
}

.input-container textarea.locked {
  background-color: var(--background-color, #f5f5f5);
  cursor: not-allowed;
}

/* 按钮区域 */
.button-bar {
  /*position: absolute;
  bottom: 1.5rem;
    right: 2.5rem;*/
  margin-bottom: rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.btn {
  padding: 5px 8px;
  border: none;
  border-radius: 5%;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: var(--primary-color, #057FDB);
  color: white;
}

.btn-primary:hover {
  background-color: var(--primary-color-dark, #0460a9);
}

.btn-secondary {
  background-color: transparent;
  color: var(--primary-color, #057FDB);
  border: 1px solid var(--primary-color, #057FDB);
}

.btn-secondary:hover {
  background-color: rgba(5, 127, 219, 0.1);
}

.btn-accent {
  background-color: var(--accent-color, #ff007f);
  color: white;
}

.btn-accent:hover {
  background-color: var(--accent-color-dark, #d9006c);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .chat-header {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem;
  }

  .chat-header h1 {
    font-size: 1.25rem;
  }

  .message-content-wrapper {
    max-width: 85%;
  }

  .avatar {
    width: 32px;
    height: 32px;
  }

  .input-container {
    padding: 0.75rem;
  }

  .button-bar {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .history-container {
    padding: 0.5rem;
  }

  .message-content-wrapper {
    max-width: 75%;
  }

  .message-container, .user-message {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .input-container textarea {
    min-height: 60px;
    font-size: 0.9rem;
  }

  .btn {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
  }
}

.markdown-ol, .markdown-ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.markdown-ol li, .markdown-ul li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.markdown-ol {
  list-style-type: decimal;
}

.markdown-ul {
  list-style-type: disc;
}

/* 确保列表项内容对齐 */
.markdown-ol li, .markdown-ul li {
  display: list-item;
  text-align: left;
}
</style>

<!-- 全局样式和主题变量 -->
<style>
:root {
  /* 默认主题变量 */
  --primary-color: #057FDB;
  --primary-color-dark: #0460a9;
  --secondary-color: #42b983;
  --accent-color: #ff007f;
  --accent-color-dark: #d9006c;
  --background-color: #f5f5f5;
  --user-msg-bg: deepskyblue;
  --assistant-msg-bg: #42b983;
  --text-color: #333333;
  --border-color: #e1e4e8;
}

/* 暗色主题 */
[data-theme="dark"] {
  --primary-color: #4FC3F7;
  --primary-color-dark: #29B6F6;
  --secondary-color: #81C784;
  --accent-color: #FF5252;
  --accent-color-dark: #F44336;
  --background-color: #263238;
  --user-msg-bg: #0288D1;
  --assistant-msg-bg: #388E3C;
  --text-color: #FFFFFF;
  --border-color: #37474F;
}

/* 企业主题 */
[data-theme="corporate"] {
  --primary-color: #1565C0;
  --primary-color-dark: #0D47A1;
  --secondary-color: #455A64;
  --accent-color: #D32F2F;
  --accent-color-dark: #B71C1C;
  --background-color: #F5F5F5;
  --user-msg-bg: #1976D2;
  --assistant-msg-bg: #455A64;
  --text-color: #212121;
  --border-color: #BDBDBD;
}

/* 代码块样式 - 独立模块 */
.code-block {
  margin: 1rem 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: var(--border-color, #e1e4e8);
  color: var(--text-color, #333333);
  font-size: 0.85rem;
  font-weight: 500;
}

.copy-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  color: inherit;
  font-size: 0.8rem;
  transition: background-color 0.2s;
}

.copy-btn:hover {
  background-color: rgba(0,0,0,0.05);
}

.code-block pre {
  margin: 0;
  padding: 1rem;
  overflow-x: auto;
  background-color: #f6f8fa;
}

/* 表格容器 */
.markdown-table-container {
  overflow-x: auto;
  margin: 1rem 0;
  max-width: 100%;
}

/* 表格基础样式 */
.markdown-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--border-color, #e1e4e8);
  background-color: white;
}

.markdown-table th,
.markdown-table td {
  padding: 0.75rem;
  border: 1px solid var(--border-color, #e1e4e8);
  line-height: 1.5;
}

 .markdown-table th {
  background-color: var(--table-header-bg, #f6f8fa);
  font-weight: 600;
  color: var(--text-color, #333);
}

.markdown-table tr:hover {
  background-color: var(--table-row-hover-bg, #f8f9fa);
}

.markdown-table td {
  font-size: 12pt;
  color: #333333;

}

/* 对齐方式 */
.table-align-left { text-align: left; }
.table-align-center { text-align: center; }
.table-align-right { text-align: right; }

/* 响应式设计 */
@media (max-width: 768px) {
  .markdown-table {
    font-size: 0.9rem;
  }

  .markdown-table th,
  .markdown-table td {
    padding: 0.5rem;
  }
}
/* 超链接样式 */
/* 超链接样式 */
.markdown-container a {
    color: var(--link-color, #057FDB);
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;
    border-bottom: 1px solid rgba(5, 127, 219, 0.3);
    padding: 0 1px;
}

.markdown-container a:hover {
    color: var(--link-hover-color, #0460a9);
    border-bottom-color: var(--link-hover-color, #0460a9);
    background-color: rgba(5, 127, 219, 0.05);
    border-radius: 2px;
}

/* 消息区域内的链接样式 */
.message-container a,
.user-message a {
    color: rgba(255, 255, 255, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.message-container a:hover,
.user-message a:hover {
    color: white;
    border-bottom-color: white;
    background-color: rgba(255, 255, 255, 0.15);
}

/* 暗色主题下的链接样式 */
[data-theme="dark"] .markdown-container a {
    color: var(--link-color, #4FC3F7);
    border-bottom-color: rgba(79, 195, 247, 0.4);
}

[data-theme="dark"] .markdown-container a:hover {
    color: var(--link-hover-color, #29B6F6);
    border-bottom-color: var(--link-hover-color, #29B6F6);
    background-color: rgba(79, 195, 247, 0.1);
}

/* 企业主题下的链接样式 */
[data-theme="corporate"] .markdown-container a {
    color: var(--link-color, #1565C0);
    border-bottom-color: rgba(21, 101, 192, 0.4);
}

[data-theme="corporate"] .markdown-container a:hover {
    color: var(--link-hover-color, #0D47A1);
    border-bottom-color: var(--link-hover-color, #0D47A1);
    background-color: rgba(21, 101, 192, 0.1);
}

/* 外部链接指示器（可选） */
.markdown-container a[target="_blank"]::after {
    content: "↗";
    margin-left: 2px;
    font-size: 0.85em;
    vertical-align: super;
    line-height: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .markdown-container a {
        word-break: break-word;
    }
}

/* 流程图样式 */
/* 紧凑型流程图样式 */
.simple-flowchart-container {
  margin: 1rem 0;
  padding: 0.8rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  font-size: 0.85em;
}

.flowchart-steps {
  display: flex;
  align-items: stretch; /* 让所有步骤框高度一致 */
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 0.5rem; /* 增加间距，让箭头在外面 */
  overflow-x: auto;
  padding: 0.3rem 0;
}

.flowchart-steps {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap; /* 禁止换行 */
  gap: 0.3rem;
  overflow-x: auto; /* 允许水平滚动 */
  padding: 0.3rem 0;
}

.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 6px;
  border: 1px solid #cce5ff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  flex-shrink: 0;
  padding: 0.3rem;
  min-width: 70px;
  max-width: 100px;
}

.step-number {
  width: 20px;
  height: 20px;
  background: #057FDB;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.7em;
  border-radius: 50%;
  margin-bottom: 0.3rem;
}

.step-content {
  padding: 0.2rem 0.3rem;
  color: #333;
  font-weight: 500;
  font-size: 0.75em;
  line-height: 1.2;
  text-align: center;
  word-wrap: break-word; /* 允许文字换行 */
  overflow-wrap: break-word;
  width: 100%;
}

.step-arrow {
  color: #057FDB;
  font-weight: bold;
  font-size: 1.1em;
  padding: 0 0.2rem;
  align-self: center;
  margin: 0 -0.2rem; /* 负边距让箭头更靠近框 */
}

/* 多行文本支持 */
.step-content br {
  display: block;
  content: "";
  margin: 0.2rem 0;
}

/* 滚动条样式 */
.flowchart-steps::-webkit-scrollbar {
  height: 4px;
}

.flowchart-steps::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 2px;
}

.flowchart-steps::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .simple-flowchart-container {
    padding: 0.6rem;
  }
}


/* 标题样式 */
.markdown-heading {
  margin: 1.5rem 0 0.75rem 0;
  font-weight: 600;
  color: var(--text-color, #333333);
  line-height: 1.3;
}

.markdown-heading h1 { font-size: 1.8rem; }
.markdown-heading h2 { font-size: 1.5rem; }
.markdown-heading h3 { font-size: 1.3rem; }
.markdown-heading h4 { font-size: 1.1rem; }
.markdown-heading h5 { font-size: 1rem; }
.markdown-heading h6 { font-size: 0.9rem; }

/* 确保在消息容器中的标题样式 */
.message-container .markdown-heading {
  color: white;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .markdown-heading h1 { font-size: 1.5rem; }
  .markdown-heading h2 { font-size: 1.3rem; }
  .markdown-heading h3 { font-size: 1.2rem; }
  .markdown-heading h4 { font-size: 1.1rem; }
}
/* 图片上传区域样式 */
.image-upload-container {
  margin-top: 0.5rem;
  padding: 0.5rem;
  border: 1px dashed var(--border-color, #e1e4e8);
  border-radius: 8px;
}

.upload-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--background-color, #f5f5f5);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.upload-label:hover {
  background-color: var(--primary-color-light, rgba(5, 127, 219, 0.1));
}

/* 图片预览区域 */
.image-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.image-preview {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background-color: rgba(255,255,255,0.8);
  color: #ff4d4f;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
}

/* 消息中的图片样式 */
.message-images {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.message-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: 4px;
  overflow: hidden;
}

.message-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .image-preview {
    width: 60px;
    height: 60px;
  }

  .message-image {
    max-width: 150px;
    max-height: 150px;
  }
}

/* 图片查看器模态框 */
.image-viewer-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.image-viewer-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  z-index: 10;
}

.close-btn:hover {
  opacity: 0.8;
}

/* 导航按钮 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.3s;
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.prev-btn {
  left: 20px;
}

.next-btn {
  right: 20px;
}

/* 图片容器 */
.image-container {
  position: relative;
  max-width: 100%;
  max-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
}

/* 加载指示器 */
.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 缩略图导航 */
.thumbnail-nav {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding: 8px;
  overflow-x: auto;
  max-width: 100%;
}

.thumbnail {
  width: 60px;
  height: 60px;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0.6;
  transition: all 0.3s;
}

.thumbnail:hover {
  opacity: 0.8;
}

.thumbnail.active {
  border-color: var(--primary-color, #057FDB);
  opacity: 1;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 图片信息 */
.image-info {
  margin-top: 12px;
  color: white;
  display: flex;
  align-items: center;
  gap: 16px;
}

.download-btn {
  color: var(--primary-color, #057FDB);
  text-decoration: none;
  padding: 4px 8px;
  border: 1px solid var(--primary-color, #057FDB);
  border-radius: 4px;
  transition: all 0.3s;
}

.download-btn:hover {
  background-color: var(--primary-color, #057FDB);
  color: white;
}

/* 消息中的图片点击效果 */
.clickable-image {
  cursor: pointer;
  transition: transform 0.2s;
}

.clickable-image:hover {
  transform: scale(1.05);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .image-viewer-content {
    max-width: 95vw;
    max-height: 95vh;
  }

  .nav-btn {
    width: 40px;
    height: 40px;
  }

  .prev-btn {
    left: 10px;
  }

  .next-btn {
    right: 10px;
  }

  .thumbnail {
    width: 40px;
    height: 40px;
  }
}
/* 错误消息样式 */
.error-message {
  padding: 0.75rem 1rem;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.error-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ff4d4f;
}

.retry-btn {
  padding: 0.25rem 0.75rem;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.retry-btn:hover {
  background-color: #d9363e;
}

/* 输入区域错误状态 */
.input-container.has-error {
  border-top: 2px solid #ff4d4f;
}
/* 上传进度样式 */
.upload-progress {
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background-color: #e1e4e8;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background-color: var(--primary-color, #057FDB);
  transition: width 0.3s ease;
}

/* 强制chat-header有明确高度 */
.chat-widget .chat-header {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  flex-wrap: nowrap !important;
  min-height: 48px !important;
  height: auto !important;
  overflow: visible !important;
}
.chat-widget .chat-header .header-info {
  display: flex !important;
  align-items: center !important;
  flex: 1 !important;
  min-width: 0 !important;
  height: auto !important;
  overflow: visible !important;
}
/* 确保子元素撑开高度 */
.chat-widget .chat-header .header-actions {
  display: flex !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  height: auto !important;
}
</style>

